(function($) {

	$(document).on('ready', function(){        
        bindEvents();
    });

	function bindEvents() {
        $(window).on('scroll', Foundation.utils.throttle(stickyHeader, 300) );
        $(document).on('opened.fndtn.reveal', '[data-reveal]', modalOpened);
        $(document).on('closed.fndtn.reveal', '[data-reveal]', modalClosed);
    }

    function modalOpened() {
        var allow_scroll = $(this).data('allow-scroll');
        if (allow_scroll) {
            return;
        }
        $('body').addClass('modal-open');
    }

    function modalClosed() {
        $('body').removeClass('modal-open');
    }

    function stickyHeader() {
        const y = window.scrollY;
        if (y > 30) {
            $('.top-bar-container').addClass('stuck');
        } else {
            $('.top-bar-container').removeClass('stuck');
        }
    }
      
} (jQuery) );
